// extracted by mini-css-extract-plugin
module.exports = {"shade":"KeyVisualArea_shade__1lUih","title":"KeyVisualArea_title__3H4U6"};